import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import {
  PrivateRouteWithLayout,
  // RouteWithLayout,
  PublicRouteWithLayout,
  // PrivateRouteWithLayout,
} from "./components";
// layouts
import DashboardLayout from "./layouts/dashboard";
import LogoOnlyLayout from "./layouts/LogoOnlyLayout";
//
import {
  ForgetPassword,
  Programmes,
  ProgrammesDetail,
  GoalStatement,
  SelfImage,
  Vault,
  Profile,
  Pods,
  Affirmations,
  AddCategory,
  EditCategory,
  Gratitude,
  Quotes,
  Memories,
  MemoriesDetail,
  AddMemories,
  EditMemories,
  DailyActivities,
  Calender,
  SupportTicket,
  LessonsDetail,
  LessonListing,
  ProgrammRecordingDetail,
  AffirmationList,
  AddGratitude,
  EditGratitude,
  AddAffirmation,
  EditAffirmation,
  StudySessionRecordingDetail,
  SupportTicketDetail,
  ConsultantRecordings,
  LandingPage,
  PaymentForm,
  ThanksPage,
  HelpingVideos,
  HelpingVideoDetail,
} from "./pages/index";
import EditProfile from "./pages/Profile/EditProfile";
import Login from "./pages/Login";
import NotFound from "./pages/Page404";
import {
  DeleteNote,
  StudySessionListing,
} from "./components/_dashboard/programmes";
import PodsDetail from "./pages/Pods/PodsDetail";
import ManagePhotos from "./components/_dashboard/goalStatement/ManagePhotos";
import { Payment } from "./components/Payment/Payment";
import BillingCard from "./components/Billing/BillingCard";
import BillingDetail from "./components/Billing/BillingDetails";
import AllTransaction from "./components/Transactions/AllTransaction";
import TransactionInformation from "./components/Transactions/TransactionInformation";
import ManageCard from "./components/ChangeCard/ManageCard";
import ChangeCreditCard from "./components/ChangeCard/ChangeCreditCard";
import NintyDayPlan from "./pages/90DayPlan/NintyDayPlan";
import NintyDayTracker from "./pages/90DayPlan/NintyDayTracker";
import AddNewEarning from "./pages/90DayPlan/AddNewEarning";
import PaymentRequests from "./components/PaymentRequests/PaymentRequests";
import PendingRequests from "./components/PaymentRequests/PendingRequests";
import ActiveRequests from "./components/PaymentRequests/ActiveRequests";
import PodcastDetail from "./pages/Webpages/PodcastDetail";
import DashboardApp from "./pages/DashboardApp";
import GeneralFaqList from "./pages/FAQ/GeneralFaqList";
import SelfImageManagePhotos from "./components/_dashboard/selfImage/SelfImageManagePhotos";
import JournalPrompts from "./pages/JournalPrompts/JournalPrompts";
import JournalPromptManagePhotos from "./components/_dashboard/journalPrompt/JournalPromptManagePhotos";
import Portals from "./pages/Portals/Portals";
import PortalDetail from "./pages/Portals/PortalDetail";
import Feed from "./pages/Feed/Feed";
import PostDetails from "./pages/Feed/PostDetails";
import AffliateLinks from "./pages/AffliateLinks/AffliateLinks";
import AffiliateInformation from "./pages/AffiliateInformation/AffiliateInformation";

// import ContentSettingState from "./Hooks/ContentSettingState";

// ----------------------------------------------------------------------
const Authentication = () => {
  if (localStorage.getItem("token")) {
    return <Navigate to="/dashboard"> </Navigate>;
  }
  if (!localStorage.getItem("token")) {
    return <Navigate to="/login"> </Navigate>;
  }
};

export default function Router() {
  return (
    // <ContentSettingState>

    <Routes>
      {/* <Route path="/" element={<LandingPage />} /> */}
      {/* <Route path="/:page_slug" element={<LandingPage />} />
      <Route path="/:page_slug/:podcast_slug" element={<PodcastDetail />} />
      <Route path="/:page_slug/payment/:plan_slug" element={<PaymentForm />} />
      <Route path="/:page_slug/thank-you/:plan_slug" element={<ThanksPage />} /> */}
      <Route element={<DashboardLayout />}>
        {<Route path="/" element={<Authentication />} />}
        <Route path="/dashboard" element={<DashboardApp />} />
        <Route path="/programs" element={<Programmes />} />
        <Route path="/programs/:slug" element={<ProgrammesDetail />} />
        <Route path="/ninety-day-plan" element={<NintyDayPlan />} />
        <Route path="/ninety-day-tracker" element={<NintyDayTracker />} />
        <Route path="/addnewearning" element={<AddNewEarning />} />
        <Route
          path="/programs/:program_slug/lessons"
          element={<LessonListing />}
        />
        <Route
          path="/study-session/:sesson_slug/study-session-recordings"
          element={<StudySessionListing />}
        />
        <Route
          path="/study-session/:sesson_slug/study-session-recording/:recording_slug"
          element={<StudySessionRecordingDetail />}
        />
        <Route path="/lessons/:lesson_slug" element={<LessonsDetail />} />
        <Route path="/affliate-links" element={<AffliateLinks />} />
        <Route path="/commission-detail" element={<AffiliateInformation />} />
        <Route
          path="/recordings/:recording_slug"
          element={<ProgrammRecordingDetail />}
        />
        <Route
          path="/lessons-recordings/:recording_slug"
          element={<ProgrammRecordingDetail />}
        />
        <Route
          path="/programs/:program_slug/lessons/:lesson_slug/:id"
          element={<DeleteNote />}
        />
        <Route path="/goal-statement" element={<GoalStatement />} />
        <Route path="/self-image" element={<SelfImage />} />
        <Route path="/journal-prompt" element={<JournalPrompts />} />
        <Route path="/replay-library" element={<Vault />} />
        <Route
          path="/consultant-recordings"
          element={<ConsultantRecordings />}
        />
        <Route path="/payment" element={<Payment />} />
        <Route path="/payment-request" element={<PaymentRequests />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/Billing" element={<BillingCard />} />
        <Route path="/change-card" element={<ChangeCreditCard />} />
        <Route path="/transaction" element={<AllTransaction />} />
        <Route
          path="/transaction/transaction-detail/:slug"
          element={<TransactionInformation />}
        />
        <Route path="/manage-card" element={<ManageCard />} />
        <Route
          path="/billing/billing-detail/:billslug"
          element={<BillingDetail />}
        />
        <Route path="/edit-profile" element={<EditProfile />} />
        <Route path="/community-rooms" element={<Pods />} />
        <Route path="/portals" element={<Portals />} />
        <Route path="/portals/:event_slug" element={<PortalDetail />} />
        <Route path="/affirmations" element={<Affirmations />} />
        <Route
          path="/affirmations/category/add-category"
          element={<AddCategory />}
        />
        <Route
          path="/affirmations/category/edit-category/:id"
          element={<EditCategory />}
        />
        <Route
          path="/affirmations/affirmation-list/:category_slug"
          element={<AffirmationList />}
        />
        <Route
          path="/community-rooms/rooms-detail/:pod_slug"
          element={<PodsDetail />}
        />
        <Route
          path="/pending-request/:request_slug"
          element={<PendingRequests />}
        />
        <Route
          path="/active-request/:request_slug"
          element={<ActiveRequests />}
        />
        <Route
          path="/goal-statement/manage-photos"
          element={<ManagePhotos />}
        />
        <Route
          path="/self-image/manage-photos"
          element={<SelfImageManagePhotos />}
        />
        <Route
          path="/journal-prompt/manage-photos"
          element={<JournalPromptManagePhotos />}
        />
        <Route
          path="/affirmations/add-affirmation"
          element={<AddAffirmation />}
        />
        <Route
          path="/affirmations/edit-affirmation/:id"
          element={<EditAffirmation />}
        />
        <Route path="/gratitude" element={<Gratitude />} />
        <Route path="/gratitude/addgratitude" element={<AddGratitude />} />
        <Route
          path="/gratitude/edit-gratitude/:id"
          element={<EditGratitude />}
        />
        <Route path="/quotes" element={<Quotes />} />
        <Route path="/memories" element={<Memories />} />
        <Route path="/memories/new-memories" element={<AddMemories />} />
        <Route path="/memories/edit-memories/:id" element={<EditMemories />} />
        <Route
          path="/memories/memories_detail/:memory_slug"
          element={<MemoriesDetail />}
        />
        <Route path="/daily_activities" element={<DailyActivities />} />
        <Route path="/calendar" element={<Calender />} />
        <Route path="/support-ticket" element={<SupportTicket />} />
        <Route path="/support-ticket/:id" element={<SupportTicketDetail />} />
        <Route path="/helping-videos" element={<HelpingVideos />} />
        <Route path="/community-news-feed" element={<Feed />} />
        <Route path="/feed-detail/:post_id" element={<PostDetails />} />
        <Route path="/helping-videos/:slug" element={<HelpingVideoDetail />} />
        <Route path="/faqs" element={<GeneralFaqList />} />
      </Route>
      <Route element={<LogoOnlyLayout />}>
        <Route path="/" element={<Authentication />} />
        <Route path="404" element={<NotFound />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forget_password" element={<ForgetPassword />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      {/* <PublicRouteWithLayout component={Login} exact layout={LogoOnlyLayout} path="/login" />
      <PublicRouteWithLayout component={Register} exact layout={LogoOnlyLayout} path="/register" /> */}
      {
        // / --------------------------------------- Dashboard --------------------------------------- /
      }
      {/* <PrivateRouteWithLayout
        component={DashboardApp}
        exact
        layout={DashboardLayout}
        path="/dashboard/app"
      /> */}
      {
        // / --------------------------------------- Change Password --------------------------------------- /
      }
      {/* <PrivateRouteWithLayout
        component={Products}
        exact
        layout={DashboardLayout}
        path="/dashboard/products"
      /> */}
    </Routes>
    // </ContentSettingState>
  );
}
//   return useRoutes([
//     {
//       path: '/dashboard',
//       element: <DashboardLayout />,
//       children: [
//         { element: <Navigate to="/dashboard/app" replace /> },
//         { path: 'app', element: <DashboardApp /> },
//         { path: 'user', element: <User /> },
//         { path: 'products', element: <Products /> },
//         { path: 'blog', element: <Blog /> }
//       ]
//     },
//     {
//       path: '/',
//       element: <LogoOnlyLayout />,
//       children: [
//         { path: 'login', element: <Login /> },
//         { path: 'register', element: <Register /> },
//         { path: '404', element: <NotFound /> },
//         { path: '/', element: <Navigate to="/dashboard" /> },
//         { path: '*', element: <Navigate to="/404" /> }
//       ]
//     },
//     { path: '*', element: <Navigate to="/404" replace /> }
//   ]);
// }
